export const DEBT = {
  nickname: 'PRODUCTS.DEBT.nickname',
  icon:'debt'
};
